import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export var initialize = createAction("".concat(actionTypePrefix, "/INITIALIZE"), function (username) { return ({
    username: username,
}); });
export var requestSuccess = createAction("".concat(actionTypePrefix, "/REQUEST_SUCCESS"), function (username, data) { return ({
    username: username,
    data: data,
}); });
export var requestFailure = createAction("".concat(actionTypePrefix, "/REQUEST_FAILURE"), function (username) { return ({ username: username }); });
//# sourceMappingURL=actionCreators.js.map